var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getObservationsCount !== 0
    ? _c("div", { staticClass: "page-navigation-container" }, [
        _vm.getPageSize <= _vm.getObservationsCount
          ? _c("div", { staticClass: "item-count-container" }, [
              _vm._v(
                _vm._s(_vm.activePage * _vm.getPageSize - _vm.getPageSize + 1) +
                  " - " +
                  _vm._s(_vm.activePage * _vm.getPageSize) +
                  " of " +
                  _vm._s(_vm.getObservationsCount) +
                  " Observations"
              )
            ])
          : _c("div", { staticClass: "item-count-container" }, [
              _vm._v(
                _vm._s(_vm.activePage * _vm.getPageSize - _vm.getPageSize + 1) +
                  " - " +
                  _vm._s(_vm.getObservationsCount) +
                  " of " +
                  _vm._s(_vm.getObservationsCount) +
                  " Observations"
              )
            ]),
        _vm._v(" "),
        _vm.getNumberOfPage <= 7 && _vm.getNumberOfPage > 1
          ? _c(
              "div",
              { staticClass: "pagination-container" },
              _vm._l(_vm.getNumberOfPage, function(page, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "ui pagination menu" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "item",
                        class: { active: _vm.activeButton === index + 1 },
                        attrs: { id: index + 1 },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectPages($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(index + 1))]
                    )
                  ]
                )
              }),
              0
            )
          : _vm.getNumberOfPage > 7
          ? _c("div", { staticClass: "pagination-container" }, [
              _c("div", { staticClass: "ui pagination menu" }, [
                _c(
                  "a",
                  {
                    staticClass: "item",
                    class: { active: _vm.activeButton == 1 },
                    attrs: { id: "1" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectPages($event)
                      }
                    }
                  },
                  [_vm._v("1")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "item",
                    class: {
                      active: _vm.activeButton == 2,
                      disabled: _vm.disabledButton <= 2
                    },
                    attrs: { id: "2" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectPages($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.pages[1]))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "item",
                    class: { active: _vm.activeButton == 3 },
                    attrs: { id: "3" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectPages($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.pages[2]))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "item",
                    class: { active: _vm.activeButton == 4 },
                    attrs: { id: "4" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectPages($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.pages[3]))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "item",
                    class: { active: _vm.activeButton == 5 },
                    attrs: { id: "5" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectPages($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.pages[4]))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "item",
                    class: {
                      active: _vm.activeButton == 2,
                      disabled: _vm.disabledButton >= 2
                    },
                    attrs: { id: "6" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectPages($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.pages[5]))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "item",
                    class: { active: _vm.activeButton == 7 },
                    attrs: { id: "7" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.selectPages($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.getNumberOfPage))]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.getObservationsCount > 10,
                expression: "getObservationsCount > 10"
              }
            ],
            staticClass: "page-size-selector-container"
          },
          [
            _vm._v(" Page size: \n  "),
            _c(
              "select",
              {
                staticClass: "ui dropdown page-size-dropdown",
                attrs: { name: "page-length", id: "page-length" },
                domProps: { value: _vm.getPageSize },
                on: {
                  input: function($event) {
                    return _vm.updatePageSize($event)
                  }
                }
              },
              [
                _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "20" } }, [_vm._v("20")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "100" } }, [_vm._v("100")])
              ]
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }